<template>
  <UButton
    class="dj-add-to-cart-btn flex flex-row items-center justify-center"
    :label="label"
    :icon="iconName"
    :size="props.size"
    color="primary"
    :variant="variant"
    :disabled="!props.isAuthenticated || isAdding || isDisabled"
    :ui="uiProps"
    :loading="isAdding"
    @click.stop="handleAddToCart"
    @mouseover="changeIcon(iconName)"
    @mouseleave="changeIcon(iconName)"
  />
</template>

<script setup lang="ts">
  import type { UpdateCartLineType } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/cart';

  interface DjAddToCartProps {
    cartId: string | undefined;
    typeId: string;
    lines: Array<{
      variantId?: string;
      offerPriceId?: string;
      quantity: number;
      updateAction: UpdateCartLineType;
    }>;
    isAuthenticated: boolean;
    isDisabled?: boolean;
    label?: string;
    size?: any;
    icon?: string;
    ui?: object;
    variant?: string;
  }

  const props = defineProps<DjAddToCartProps>();
  const emit = defineEmits(['addedToCart', 'errorToCart']);
  const { addOrUpdateCartLine } = useCart();
  const isAdding = ref(false);
  const { getUserCurrency } = useUser();
  const currency = computed(() => getUserCurrency());
  const uiProps = props.ui ?? { base: 'p-2 rounded-sm' };

  const handleAddToCart = async () => {
    if (!props.isAuthenticated || !props.cartId) return;

    try {
      isAdding.value = true;

      const response = await addOrUpdateCartLine({
        currency: currency.value,
        cartId: props.cartId,
        typeId: props.typeId,
        lines: props.lines,
      });

      emit('addedToCart', response);
    } catch (error) {
      console.error('Failed to add products to cart:', error);
      emit('errorToCart', error);
    } finally {
      isAdding.value = false;
    }
  };

  const iconName = ref(props.icon ?? 'djust-icon:cart-primary');

  const changeIcon = (newIcon: string) => {
    if (!props.icon) iconName.value = newIcon;
  };
</script>

<style lang="scss"></style>
